import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_CANVAS_SCHEMA = Object.freeze({
  CANVAS_IDENTIFIER: '',
  CANVAS_TYPE: '',
  CANVAS_CATEGORY: '',
  CTA_1_BUTTON_IDENTIFIER: '',
  CTA_2_BUTTON_IDENTIFIER: '',
});
const RECORD = generateSchema(TRACKING_CANVAS_SCHEMA);
const KEYS: any = generateKeys(TRACKING_CANVAS_SCHEMA);

export class CanvasTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.canvas;
  }

  get properties() {
    return this.toJS();
  }
}
